<template>
  <div>
    <img :src="storeAnswer.data.value">
    <span>{{storeAnswer.data.name}}</span>
  </div>
</template>
<script>
import mixin from './_mixin_display'
export default { mixins: [mixin] }
</script>